export default {
  PRACTICE_NAME_ASC: 'PRACTICE_NAME_ASC',
  PRACTICE_NAME_DESC: 'PRACTICE_NAME_DESC',
  ADDED_ON_NEWEST_TO_OLDEST: 'ADDED_ON_NEWEST_TO_OLDEST',
  ADDED_ON_OLDEST_TO_NEWEST: 'ADDED_ON_OLDEST_TO_NEWEST',
  INVITE_DATE_OLDEST_TO_NEWEST: 'INVITE_DATE_OLDEST_TO_NEWEST',
  INVITE_DATE_NEWEST_TO_OLDEST: 'INVITE_DATE_NEWEST_TO_OLDEST',

  CUSTOMER_NAME_ASC: 'PRACTICE_NAME_ASC',
  CUSTOMER_NAME_DESC: 'PRACTICE_NAME_DESC',
} as const
